import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { ExpandingWildsBulkFactory , ExpandingWildsBulk , ExpandingWildsBulkParam, ExpandingWildsBulkConfig } from "../../slot/ExpandingWildBulk";
import { Rect } from "../.././MyHelpers";
//namespace SlotGames {
	export class WildFire100_Responsive extends SlotGameType1_Responsive {

		
		protected override helpFactory: IHelpFactory = new WildFire100HelpFactory();
        protected override expandingWildsFactory: ExpandingWildsBulkFactory = new WildFire100ExpandingWildsBulkFactory();
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "WildFire100");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		}

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
		// }
	        //SEND COLOR 
			protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

    }

    //Help Colorized
    class WildFire100HelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new WildFire100Help(params);
        }
    }

    class WildFire100Help extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
    class WildFire100ExpandingWildsBulkFactory extends ExpandingWildsBulkFactory
	{
		public override CreateExpandingWildsBulk(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig): ExpandingWildsBulk 
		{
			return new WildFire100ExpandingWildsBulk(param, config);
		}

	}

    class WildFire100ExpandingWildsBulk extends ExpandingWildsBulk
	{
		public override InflateWildSize(wildRect: Rect): Rect
		{
			return wildRect;
		}
	}
//}
